module.exports = __webpack_public_path__ + "img/icon_inno.cc419c85.png";